import { FidelityBlocksProps } from "@/interfaces/loyaltyProgram";
import styles from "./FidelityBlocks.module.scss";
import FidelityBlock from "./fidelityBlock/FidelityBlock";

const FidelityBlocks = ({ title, fidelityBlocks }: FidelityBlocksProps) => {
  return (
    <div className={styles.fidelityBlocksContainer}>
      <h2 className={styles.fidelityBlockTitle}>{title}</h2>
      <div className={styles.fidelityBlocks}>
        {fidelityBlocks?.map((fidelityBlock, index) => {
          return <FidelityBlock {...fidelityBlock} key={index}></FidelityBlock>;
        })}
      </div>
    </div>
  );
};

export default FidelityBlocks;
